<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="visible">        
        <div class="skin-modal u-window">           
            <div class="dialog-content">              
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <div class="skin-panel">
                        <div class="layer-char" :class="['char-' + active , {'switch' : btn_switch}]"></div>

                        <div class="layer-text" :class="'text-' + active"></div>

                        <div class="skin-more" @click="call_detail" v-if="active != 7"></div>

                        <div class="tips" :class="'tip-' + active"></div>

                        <div class="u-switch" v-if="active == 0">
                            <div class="u-btn normal" :class="{'act' : !btn_switch}" @click="btn_switch = false"></div>
                            <div class="u-btn limit" :class="{'act' : btn_switch}" @click="btn_switch = true"></div>
                        </div>
                    </div>

                    <div class="char-select">
                        <div class="prev u-btn" :class="{'disabled' : active == 0}" @click="prev"></div>
                        <ul>
                            <li v-for="n in 8" :key="n" @click="active = (n - 1)" :class="{'act' : active == (n - 1)}">
                                <div class="pic u-btn" :class="'c-' + n"></div>
                            </li>
                        </ul>
                        <div class="next u-btn" :class="{'disabled' : active == 7}" @click="next"></div>
                    </div>

                </div>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    data : function () {
        return {
            visible : false,
            active : 0,
            btn_switch : false,
            char_clz : 'char-' + this.active,
            _scrollTop : 0,
            opt : {
                passive: false, //强调默认事件
                capture: true, //早点禁止该事件               
            }
        }
    },
    created (){
        //this.render();
        this.afterOpen();
    },   
    methods: {
        destroyElement () {
            this.beforeClose();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        prev (){
            if(this.active == 0)return;
            this.active = Math.max(0,this.active - 1);
        },
        next (){
            if(this.active == 7)return;
            this.active = Math.min(7,this.active + 1);
        },
        call_detail(){
            this.$detail_modal({active : this.active, skin_switch : this.btn_switch});
        },
        stopTouch(e){
            e.preventDefault();
        },        
        afterOpen () {
            document.body.style.overflow = 'hidden';
            document.addEventListener('touchmove', this.stopTouch, this.opt); // 禁止页面滑动          
        },
        beforeClose (){
            document.body.style.overflow = ''; // 出现滚动条
            document.removeEventListener('touchmove', this.stopTouch, this.opt);         
        },
    }    
}
</script>

<style scoped>
@media only screen and (min-width: 1281px) {
.skin-panel{
    position: relative;
    width: 1011px;
    height: 579px;
    margin: 0 auto;
    background-image: url(~@/assets/images/pc/skin/skin-panel.png);
}

.u-switch{
    position: absolute;
    left: 86px;
    bottom: 135px;
}

.u-switch .u-btn{
    width: 99px;
    height: 25px;
    background-repeat: no-repeat;
}

.u-btn.normal{
    margin-bottom: 5px;
    background-image: url(~@/assets/images/pc/skin/1/btn-normal.png);
}

.u-btn.normal.act{
    background-image: url(~@/assets/images/pc/skin/1/btn-normal_act.png);
}

.u-btn.limit{
    margin-left: -2px;
    background-image: url(~@/assets/images/pc/skin/1/btn-limit.png);
}

.u-btn.limit.act{
    background-image: url(~@/assets/images/pc/skin/1/btn-limit_act.png);
}

.layer-char{
    position: absolute;
}

.layer-char.char-0{
    left: 70px;
    bottom: 80px;    
    width: 975px;
    height: 612px;
    background-image: url(~@/assets/images/pc/skin/1/skin-1.png);
}

.layer-char.char-0.switch{
    left: 70px;
    bottom: 80px;    
    width: 975px;
    height: 612px;
    background-image: url(~@/assets/images/pc/skin/1/skin-2.png);
}

.layer-char.char-1{
    left: -24px;
    bottom: 80px;    
    width: 952px;
    height: 629px;
    background-image: url(~@/assets/images/pc/skin/2/skin.png);
}

.layer-char.char-2{
    left: 52px;
    bottom: 80px;    
    width: 874px;
    height: 625px;
    background-image: url(~@/assets/images/pc/skin/3/skin.png);
}

.layer-char.char-3{
    left: 58px;
    bottom: 80px;    
    width: 869px;
    height: 599px;
    background-image: url(~@/assets/images/pc/skin/4/skin.png);
}

.layer-char.char-4{
    left: 65px;
    bottom: 80px;    
    width: 861px;
    height: 612px;
    background-image: url(~@/assets/images/pc/skin/5/skin.png);
}

.layer-char.char-5{
    left: -26px;
    bottom: 80px;    
    width: 954px;
    height: 571px;
    background-image: url(~@/assets/images/pc/skin/6/skin.png);
}

.layer-char.char-6{
    left: 46px;
    bottom: 80px;    
    width: 882px;
    height: 613px;
    background-image: url(~@/assets/images/pc/skin/7/skin.png);
}

.layer-char.char-7{
    left: 60px;
    bottom: 80px;    
    width: 910px;
    height: 579px;
    background-image: url(~@/assets/images/pc/skin/8/skin.png);
}

.layer-text{
    position: absolute;
    top: -90px;
    right: 130px;
}

.layer-text.text-0{
    width: 137px;
    height: 515px;
    background-image: url(~@/assets/images/pc/skin/1/text.png);    
}

.layer-text.text-1{
    width: 137px;
    height: 515px;
    background-image: url(~@/assets/images/pc/skin/2/text.png);    
}

.layer-text.text-2{
    width: 137px;
    height: 515px;
    background-image: url(~@/assets/images/pc/skin/3/text.png);    
}

.layer-text.text-3{
    width: 137px;
    height: 515px;
    background-image: url(~@/assets/images/pc/skin/4/text.png);    
}

.layer-text.text-4{
    width: 137px;
    height: 515px;
    background-image: url(~@/assets/images/pc/skin/5/text.png);    
}

.layer-text.text-5{
    width: 137px;
    height: 515px;
    background-image: url(~@/assets/images/pc/skin/6/text.png);    
}

.layer-text.text-6{
    width: 137px;
    height: 515px;
    background-image: url(~@/assets/images/pc/skin/7/text.png);    
}

.layer-text.text-7{
    width: 137px;
    height: 515px;
    background-image: url(~@/assets/images/pc/skin/8/text.png);    
}

.skin-more{
    position: absolute;
    left: 50%;
    bottom: 96px;
    width: 358px;
    height: 205px;
    transform: translate(-50%,0);
    background-image: url(~@/assets/images/pc/skin/skin-more.png);
}

.tips{
    position: absolute;
    left: 50%;
    bottom: 120px;
    transform: translate(-50%,0);    
}

.tips.tip-0{
    width: 265px;
    height: 37px;
    background-image: url(~@/assets/images/pc/skin/1/tip.png);
}

.tips.tip-1{
    width: 265px;
    height: 37px;
    background-image: url(~@/assets/images/pc/skin/2/tip.png);
}

.tips.tip-2{
    width: 265px;
    height: 37px;
    background-image: url(~@/assets/images/pc/skin/3/tip.png);
}

.tips.tip-3{
    width: 265px;
    height: 37px;
    background-image: url(~@/assets/images/pc/skin/4/tip.png);
}

.tips.tip-4{
    width: 265px;
    height: 37px;
    background-image: url(~@/assets/images/pc/skin/5/tip.png);
}

.tips.tip-5{
    width: 215px;
    height: 37px;
    background-image: url(~@/assets/images/pc/skin/6/tip.png);
}

.tips.tip-6{
    width: 265px;
    height: 37px;
    background-image: url(~@/assets/images/pc/skin/7/tip.png);
}

.tips.tip-7{
    width: 265px;
    height: 37px;
    background-image: url(~@/assets/images/pc/skin/8/tip.png);
}

.char-select{
    display: flex;
    position: relative;
    margin-top: -110px;
    justify-content: center;
}

.char-select ul{
    display: flex;
    margin-left: 20px;
}

.char-select li{
    margin-left: -20px;
}

.char-select li:nth-child(2n){
    margin-top: -20px;
}

.char-select .pic{
    width: 120px;
    height: 120px;
    background-repeat: no-repeat;
    background-position: top center;
}

.char-select .pic.c-1{
    background-image: url(~@/assets/images/pc/select/s-1.png);
}

.char-select .pic.c-1:hover,
.char-select .act .pic.c-1{
    background-image: url(~@/assets/images/pc/select/act/s-1.png);
}

.char-select .pic.c-2{
    background-image: url(~@/assets/images/pc/select/s-2.png);
}

.char-select .pic.c-2:hover,
.char-select .act .pic.c-2{
    background-image: url(~@/assets/images/pc/select/act/s-2.png);
}

.char-select .pic.c-3{
    background-image: url(~@/assets/images/pc/select/s-3.png);
}

.char-select .pic.c-3:hover,
.char-select .act .pic.c-3{
    background-image: url(~@/assets/images/pc/select/act/s-3.png);
}

.char-select .pic.c-4{
    background-image: url(~@/assets/images/pc/select/s-4.png);
}

.char-select .pic.c-4:hover,
.char-select .act .pic.c-4{
    background-image: url(~@/assets/images/pc/select/act/s-4.png);
}

.char-select .pic.c-5{
    background-image: url(~@/assets/images/pc/select/s-5.png);
}

.char-select .pic.c-5:hover,
.char-select .act .pic.c-5{
    background-image: url(~@/assets/images/pc/select/act/s-5.png);
}

.char-select .pic.c-6{
    background-image: url(~@/assets/images/pc/select/s-6.png);
}

.char-select .pic.c-6:hover,
.char-select .act .pic.c-6{
    background-image: url(~@/assets/images/pc/select/act/s-6.png);
}

.char-select .pic.c-7{
    background-image: url(~@/assets/images/pc/select/s-7.png);
}

.char-select .pic.c-7:hover,
.char-select .act .pic.c-7{
    background-image: url(~@/assets/images/pc/select/act/s-7.png);
}

.char-select .pic.c-8{
    background-image: url(~@/assets/images/pc/select/s-8.png);
}

.char-select .pic.c-8:hover,
.char-select .act .pic.c-8{
    background-image: url(~@/assets/images/pc/select/act/s-8.png);
}

.prev{
    position: absolute;
    left: 40px;
    top: 50%;
    width: 77px;
    height: 85px;
    background-image: url(~@/assets/images/pc/skin/skin-swiper.png);
    transform: translateY(-50%);
    z-index: 2;
}

.next{
    position: absolute;
    right: 40px;
    top: 50%;
    width: 77px;
    height: 85px;
    background-image: url(~@/assets/images/pc/skin/skin-swiper.png);
    transform: translateY(-50%) rotate(180deg);
    z-index: 2;
}

}

@media only screen and (max-width: 1281px) {
.skin-panel{
    position: relative;
    width: 750px;
    height: 579px;
    margin: 0 auto;
    background-image: url(~@/assets/images/m/skin/skin-panel.png);
}

.u-switch{
    position: absolute;
    left: 0;
    bottom: 135px;
}

.u-switch .u-btn{
    width: 144px;
    height: 38px;
    background-repeat: no-repeat;
}

.u-btn.normal{
    margin-bottom: 5px;
    background-image: url(~@/assets/images/m/skin/1/btn-normal.png);
}

.u-btn.normal.act{
    background-image: url(~@/assets/images/m/skin/1/btn-normal_act.png);
}

.u-btn.limit{
    margin-left: -2px;
    background-image: url(~@/assets/images/m/skin/1/btn-limit.png);
}

.u-btn.limit.act{
    background-image: url(~@/assets/images/m/skin/1/btn-limit_act.png);
}

.u-btn.close{
    top: 105%;
    left: 50%;
    width: 32px;
    height: 34px;
    transform: translateX(-50%);
    background-image: url(~@/assets/images/m/skin/btn-close.png);
}

.layer-char{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
}

.layer-char.char-0{
    bottom: 80px;    
    width: 750px;
    height: 612px;
    background-image: url(~@/assets/images/m/skin/1/skin-1.png);
}

.layer-char.char-0.switch{
    bottom: 80px;    
    width: 750px;
    height: 612px;
    background-image: url(~@/assets/images/m/skin/1/skin-2.png);
}

.layer-char.char-1{
    bottom: 80px;    
    width: 750px;
    height: 629px;
    background-image: url(~@/assets/images/m/skin/2/skin.png);
}

.layer-char.char-2{
    bottom: 80px;    
    width: 750px;
    height: 625px;
    background-image: url(~@/assets/images/m/skin/3/skin.png);
}

.layer-char.char-3{
    bottom: 80px;    
    width: 750px;
    height: 599px;
    background-image: url(~@/assets/images/m/skin/4/skin.png);
}

.layer-char.char-4{
    bottom: 80px;    
    width: 750px;
    height: 612px;
    background-image: url(~@/assets/images/m/skin/5/skin.png);
}

.layer-char.char-5{
    bottom: 80px;    
    width: 744px;
    height: 571px;
    background-image: url(~@/assets/images/m/skin/6/skin.png);
}

.layer-char.char-6{
    bottom: 80px;    
    width: 750px;
    height: 613px;
    background-image: url(~@/assets/images/m/skin/7/skin.png);
}

.layer-char.char-7{
    bottom: 80px;    
    width: 750px;
    height: 579px;
    background-image: url(~@/assets/images/m/skin/8/skin.png);
}

.layer-text{
    position: absolute;
    top: -90px;
    right: 0;
}

.layer-text.text-0{
    width: 137px;
    height: 515px;
    background-image: url(~@/assets/images/m/skin/1/text.png);    
}

.layer-text.text-1{
    width: 137px;
    height: 515px;
    background-image: url(~@/assets/images/m/skin/2/text.png);    
}

.layer-text.text-2{
    width: 137px;
    height: 515px;
    background-image: url(~@/assets/images/m/skin/3/text.png);    
}

.layer-text.text-3{
    width: 137px;
    height: 515px;
    background-image: url(~@/assets/images/m/skin/4/text.png);    
}

.layer-text.text-4{
    width: 137px;
    height: 515px;
    background-image: url(~@/assets/images/m/skin/5/text.png);    
}

.layer-text.text-5{
    width: 137px;
    height: 515px;
    background-image: url(~@/assets/images/m/skin/6/text.png);    
}

.layer-text.text-6{
    width: 137px;
    height: 515px;
    background-image: url(~@/assets/images/m/skin/7/text.png);    
}

.layer-text.text-7{
    width: 137px;
    height: 515px;
    background-image: url(~@/assets/images/m/skin/8/text.png);    
}

.skin-more{
    position: absolute;
    left: 50%;
    bottom: 96px;
    width: 358px;
    height: 205px;
    transform: translate(-50%,0);
    background-image: url(~@/assets/images/m/skin/skin-more.png);
}

.tips{
    position: absolute;
    left: 50%;
    bottom: 120px;
    transform: translate(-50%,0);    
}

.tips.tip-0{
    width: 265px;
    height: 37px;
    background-image: url(~@/assets/images/m/skin/1/tip.png);
}

.tips.tip-1{
    width: 265px;
    height: 37px;
    background-image: url(~@/assets/images/m/skin/2/tip.png);
}

.tips.tip-2{
    width: 265px;
    height: 37px;
    background-image: url(~@/assets/images/m/skin/3/tip.png);
}

.tips.tip-3{
    width: 265px;
    height: 37px;
    background-image: url(~@/assets/images/m/skin/4/tip.png);
}

.tips.tip-4{
    width: 265px;
    height: 37px;
    background-image: url(~@/assets/images/m/skin/5/tip.png);
}

.tips.tip-5{
    width: 215px;
    height: 37px;
    background-image: url(~@/assets/images/m/skin/6/tip.png);
}

.tips.tip-6{
    width: 265px;
    height: 37px;
    background-image: url(~@/assets/images/m/skin/7/tip.png);
}

.tips.tip-7{
    width: 265px;
    height: 37px;
    background-image: url(~@/assets/images/m/skin/8/tip.png);
}

.char-select{
    display: flex;
    position: relative;
    width: 750px;
    margin-top: -110px;
    justify-content: space-between;
}

.char-select ul{
    display: flex;
    margin-left: 20px;
}

.char-select li{
    margin-left: -20px;
}

.char-select li:nth-child(2n){
    margin-top: -20px;
}

.char-select .pic{
    width: 120px;
    height: 120px;
    margin-left: -10px;
    background-repeat: no-repeat;
    background-position: top center;
}
.char-select .pic.c-1{
    background-image: url(~@/assets/images/pc/select/s-1.png);
}

.char-select .pic.c-1:hover,
.char-select .act .pic.c-1{
    background-image: url(~@/assets/images/pc/select/act/s-1.png);
}

.char-select .pic.c-2{
    background-image: url(~@/assets/images/pc/select/s-2.png);
}

.char-select .pic.c-2:hover,
.char-select .act .pic.c-2{
    background-image: url(~@/assets/images/pc/select/act/s-2.png);
}

.char-select .pic.c-3{
    background-image: url(~@/assets/images/pc/select/s-3.png);
}

.char-select .pic.c-3:hover,
.char-select .act .pic.c-3{
    background-image: url(~@/assets/images/pc/select/act/s-3.png);
}

.char-select .pic.c-4{
    background-image: url(~@/assets/images/pc/select/s-4.png);
}

.char-select .pic.c-4:hover,
.char-select .act .pic.c-4{
    background-image: url(~@/assets/images/pc/select/act/s-4.png);
}

.char-select .pic.c-5{
    background-image: url(~@/assets/images/pc/select/s-5.png);
}

.char-select .pic.c-5:hover,
.char-select .act .pic.c-5{
    background-image: url(~@/assets/images/pc/select/act/s-5.png);
}

.char-select .pic.c-6{
    background-image: url(~@/assets/images/pc/select/s-6.png);
}

.char-select .pic.c-6:hover,
.char-select .act .pic.c-6{
    background-image: url(~@/assets/images/pc/select/act/s-6.png);
}

.char-select .pic.c-7{
    background-image: url(~@/assets/images/pc/select/s-7.png);
}

.char-select .pic.c-7:hover,
.char-select .act .pic.c-7{
    background-image: url(~@/assets/images/pc/select/act/s-7.png);
}

.char-select .pic.c-8{
    background-image: url(~@/assets/images/pc/select/s-8.png);
}

.char-select .pic.c-8:hover,
.char-select .act .pic.c-8{
    background-image: url(~@/assets/images/pc/select/act/s-8.png);
}
}

</style>


// WEBPACK FOOTER //
// src/components/SkinModal/skinModal.vue